// extracted by mini-css-extract-plugin
export var aircallIframe = "_j5-3";
export var fabContainer = "_j5-5";
export var fabRinging = "_j5-6";
export var loadingOverlay = "_j5-4";
export var pulse = "_j5-7";
export var widgetContent = "_j5-2";
export var widgetPanel = "_j5-0";
export var widgetPanelExpanded = "_j5-1";